interface LocationSectionProps {
  onRegisterClick: () => void;
}

export default function LocationSection({ onRegisterClick }: LocationSectionProps) {
  return (
    <section id="how-to-get" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#c8963e] mb-4">
            Практическая информация
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#0f3d32] leading-tight">
            Как попасть на конференцию
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-start">
          <div className="w-full lg:w-[45%] space-y-8">
            <div className="bg-gradient-to-br from-[#0f3d32] to-[#1a6b5a] rounded-2xl p-8 text-white">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#c8963e] rounded-xl shrink-0">
                  <i className="ri-user-add-line text-white text-lg"></i>
                </div>
                <h3 className="text-xl font-extrabold">Регистрация</h3>
              </div>
              <p className="text-white/80 text-sm leading-relaxed mb-6">
                Участие <strong className="text-white">бесплатное</strong> при условии обязательной предварительной регистрации.
              </p>
              <button
                onClick={onRegisterClick}
                className="w-full bg-[#c8963e] hover:bg-[#b07e30] text-white font-bold py-4 rounded-full transition-all hover:-translate-y-0.5 cursor-pointer whitespace-nowrap text-base"
              >
                Зарегистрироваться
              </button>
              <p className="text-white/50 text-xs text-center mt-3">
                Регистрируйтесь! Количество мест ограничено.
              </p>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-4 p-5 bg-[#f5f2ed] rounded-2xl">
                <div className="w-11 h-11 flex items-center justify-center bg-[#c8963e]/10 rounded-xl shrink-0">
                  <i className="ri-building-line text-[#c8963e] text-xl"></i>
                </div>
                <div>
                  <div className="font-bold text-[#0f3d32] text-sm mb-1">Место проведения</div>
                  <div className="text-gray-600 text-sm leading-relaxed">
                    Гостиница «Москва»<br />
                    пл. Александра Невского, д. 2, Санкт-Петербург
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4 p-5 bg-[#f5f2ed] rounded-2xl">
                <div className="w-11 h-11 flex items-center justify-center bg-[#1a6b5a]/10 rounded-xl shrink-0">
                  <i className="ri-train-line text-[#1a6b5a] text-xl"></i>
                </div>
                <div>
                  <div className="font-bold text-[#0f3d32] text-sm mb-1">Метро</div>
                  <div className="text-gray-600 text-sm">
                    «Площадь Александра Невского»<br />
                    <span className="text-[#1a6b5a] font-medium">выход прямо к гостинице</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[55%]">
            <div className="rounded-2xl overflow-hidden h-96 md:h-[520px]">
              <iframe
                src="https://yandex.ru/map-widget/v1/?ll=30.3861%2C59.9241&z=16&pt=30.3861%2C59.9241%2Cpm2rdm&text=%D0%93%D0%BE%D1%81%D1%82%D0%B8%D0%BD%D0%B8%D1%86%D0%B0+%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0%2C+%D0%BF%D0%BB.+%D0%90%D0%BB%D0%B5%D0%BA%D1%81%D0%B0%D0%BD%D0%B4%D1%80%D0%B0+%D0%9D%D0%B5%D0%B2%D1%81%D0%BA%D0%BE%D0%B3%D0%BE+2%2C+%D0%A1%D0%B0%D0%BD%D0%BA%D1%82-%D0%9F%D0%B5%D1%82%D0%B5%D1%80%D0%B1%D1%83%D1%80%D0%B3"
                width="100%"
                height="100%"
                frameBorder="0"
                title="Карта — Гостиница Москва, СПб"
                allowFullScreen
              ></iframe>
            </div>
            <p className="text-center text-sm text-gray-400 mt-3">
              Гостиница «Москва», пл. Александра Невского, 2, Санкт-Петербург
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
